import { QuestionTypes } from "../../../../Questions/constant";
import {HotQuestion} from "./HotQuestion";
import { AssertionReasoning } from "./AssertionQuestion";

const getStatusClass = (status) => {
  if (status === "correct") return "correct";
  if (status === "incorrect") return "wrong";
  if (status === "unattempted") return "unattempted";
  return "neutral";
};

export function Question(props) {
  const status = getStatusClass(props.attempt?.status);
  if(props.question.questionType === QuestionTypes.DESCRIPTIVE)
    return <HotQuestion {...props} status={status}/>;
  if(props.question.questionType === QuestionTypes.ASSERTION_REASONING)
    return <AssertionReasoning {...props} status={status}/>
  return <></>;
}